/**
 * 全局过滤器
 */
import format from 'date-fns/format';

const filters = {
  // 日期格式化
  formatDate: function(value, formatStr = 'YYYY-MM-DD HH:mm:ss') {
    if (!value) {
      return '';
    }

    let date = value;
    if (typeof date === 'string') {
      if (date.includes('-')) {
        date = date.split('-').join('/');
      }
      date = new Date(date);
    }

    return format(date, formatStr);
  },
  // 截取姓名显示成头像
  formatUserName: function(name) {
    let res = name.trim();
    if (res && res.length > 2) {
      res = res.slice(-2);
    }
    return res;
  }
};

export default filters;
